<template src="./ReturnHistory.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  name: "return-history",
  props: ["patientId"],
  data() {
    return {
      history: []
    };
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getReturnHistory();
    },
    getReturnHistory() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$props.patientId +
            "/returns?page=0&size=50&sort=createDate,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.history = response.data.content;
          }
        });
    },
    goBackToScheduleHistory(){
      const vm = this;
      vm.$emit("goToScheduleHistory", event);
    },
    fillTableScheduleHistory() {
      const vm = this;
      for (let h in vm.history) {
        if (vm.testNullUndefinedEmpty(vm.history[h].doctor)) {
          vm.history[h].doctor = "Sem registro";
        } else {
          vm.history[h].doctor = vm.history[h].doctor;
        }
        if (vm.testNullUndefinedEmpty(vm.history[h].zipcode)) {
          vm.history[h].zipcode = "Sem registro";
        } else {
          vm.history[h].zipcode =
            vm.history[h].zipcode.substring(0, 5) +
            "-" +
            vm.history[h].zipcode.substring(5, 10);
        }
 
        switch (vm.history[h].status) {
          case "SCHEDULED":
            vm.history[h].status = "Agendada";
            break;
          case "CANCELLED_BY_EXPIRED":
            vm.history[h].status = "Expirado (24 horas)";
            break;
          case "CANCELLED_BY_PATIENT":
            vm.history[h].status = "Solicitação cancelada";
            break;
          case "HISTORY_CONCLUDED":
            vm.history[h].status = "Realizada";
            break;
          case "HISTORY_CANCELLED":
            vm.history[h].status = "Solicitação cancelada";
            break;
          case "CONFIRMED":
            vm.history[h].status = "Confirmada";
            break;
          case "WAITING_APPROVE":
            vm.history[h].status = "Aguardando aceite do paciente";
            break;
          case "WAITING_MATCH":
            vm.history[h].status = "Aguardando match";
            break;
          default:
            vm.history[h].status = "Status não registrado";
            break;
        }
      }
    }
  }
};
</script>
<style src="./ReturnHistory.css">
</style>